import React, { useState } from 'react';

const NarrativeBuilder = () => {
  const [formData, setFormData] = useState({ q1: '', q2: '', q3: '' });
  const [submissions, setSubmissions] = useState([]);
  const [viewMode, setViewMode] = useState(false);


  const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxJt7AdUnv41wBCY3e2m_tasRiiT4WxdperxfZi9mobJRZ6O60upX4y_ivvGzw72jem/exec";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch(SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors', // Google Apps Script ke liye zaroori hai
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      alert("Test Submitted Successfully to Excel.");
      setFormData({ q1: '', q2: '', q3: '' });
    } catch (error) {
      alert("Error submitting test.");
    }
  };

  const fetchSubmissions = async () => {
    try {
      const response = await fetch(SCRIPT_URL);
      const data = await response.json();
      setSubmissions(data);
      setViewMode(true);
    } catch (error) {
      alert("Error fetching data. Check if Script is deployed as 'Anyone'.");
    }
  };

  const styles = {
    pageWrapper: {
      width: '100%',
      height: '100vh',
      overflowY: 'auto',
      backgroundColor: '#f9fafb',
      fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
      display: 'block' 
    },
    container: {
      maxWidth: '800px',
      margin: '60px auto',
      padding: '0 20px',
      paddingBottom: '100px'
    },
    card: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      border: '1px solid #e5e7eb',
      padding: '40px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    },
    mainTitle: {
      fontSize: '32px',
      fontWeight: '800',
      color: '#111827',
      marginBottom: '8px'
    },
    timer: {
      fontSize: '14px',
      color: '#6b7280',
      marginBottom: '24px',
      display: 'block'
    },
    instructionBox: {
      backgroundColor: '#111827',
      color: '#ffffff',
      padding: '24px',
      borderRadius: '8px',
      marginBottom: '40px',
      lineHeight: '1.6'
    },
    qTitle: {
      fontSize: '20px',
      fontWeight: '700',
      color: '#111827',
      marginTop: '40px',
      marginBottom: '16px',
      display: 'block',
      borderLeft: '4px solid #000',
      paddingLeft: '12px'
    },
    guidance: {
      fontSize: '14px',
      color: '#4b5563',
      backgroundColor: '#f3f4f6',
      padding: '16px',
      borderRadius: '6px',
      marginBottom: '16px',
      lineHeight: '1.5'
    },
    textarea: {
      width: '100%',
      minHeight: '120px',
      padding: '16px',
      borderRadius: '8px',
      border: '1.5px solid #d1d5db',
      fontSize: '16px',
      outline: 'none',
      transition: 'border-color 0.2s',
      boxSizing: 'border-box',
      fontFamily: 'inherit'
    },
    input: {
      width: '100%',
      padding: '16px',
      borderRadius: '8px',
      border: '1.5px solid #d1d5db',
      fontSize: '16px',
      outline: 'none',
      boxSizing: 'border-box'
    },
    submitBtn: {
      marginTop: '40px',
      width: '100%',
      padding: '18px',
      backgroundColor: '#000',
      color: '#fff',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer'
    },
    adminBtn: {
      marginBottom: '10px',
      padding: '8px 12px',
      fontSize: '12px',
      cursor: 'pointer',
      backgroundColor: '#eee',
      border: 'none',
      borderRadius: '4px'
    }
  };

  if (viewMode) {
    return (
      <div style={styles.pageWrapper}>
        <div style={styles.container}>
          <button onClick={() => setViewMode(false)} style={styles.adminBtn}>Back to Form</button>
          <h1 style={styles.mainTitle}>Submissions</h1>
          {submissions.map((s, i) => (
            <div key={i} style={{...styles.card, marginBottom: '20px'}}>
              <p><strong>Date:</strong> {new Date(s.timestamp).toLocaleString()}</p>
              <p><strong>Q1:</strong> {s.q1}</p>
              <p><strong>Q2:</strong> {s.q2}</p>
              <p><strong>Q3:</strong> {s.q3}</p>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div style={styles.pageWrapper}>
      <div style={styles.container}>
       
        <div style={styles.card}>
          <h1 style={styles.mainTitle}>Narrative Builder Test</h1>
          <span style={styles.timer}>(Time: 15–20 mins)</span>

          <div style={styles.instructionBox}>
            <strong style={{color: '#fbbf24'}}>👉 Important Instruction:</strong>
            <p style={{marginTop: '10px', fontSize: '15px'}}>
              This is not a marketing copy test. We are evaluating how you think, frame problems, and build meaning.
            </p>
            <ul style={{fontSize: '14px', marginTop: '10px', opacity: 0.9}}>
              <li>Avoid generic words (quality, innovative, etc.)</li>
              <li>No feature descriptions</li>
              <li>Focus on human emotions and beliefs</li>
            </ul>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{marginBottom: '50px'}}>
              <label style={styles.qTitle}>Q1: Reframing the Ordinary (Core Skill)</label>
              <p style={{fontSize: '16px', fontWeight: '500', marginBottom: '10px'}}>A company sells plain white T-shirts.</p>
              <div style={styles.guidance}>
                <strong>Guidance:</strong> Think about identity, simplicity, or rebellion. What does it say about the wearer? You are selling a meaning, not fabric.
              </div>
              <textarea name="q1" value={formData.q1} style={styles.textarea} onChange={handleChange} required placeholder="In 3–4 lines..." />
            </div>

            <div style={{marginBottom: '50px'}}>
              <label style={styles.qTitle}>Q2: Build a Movement (Tagline + Thinking)</label>
              <p style={{fontSize: '16px', fontWeight: '500', marginBottom: '10px'}}>Create 1 bold tagline for a productivity app.</p>
              <div style={styles.guidance}>
                <strong>Constraints:</strong> No features. It should feel like a belief or philosophy.
              </div>
              <input name="q2" value={formData.q2} style={styles.input} onChange={handleChange} required placeholder="Bold tagline..." />
            </div>

            <div style={{marginBottom: '50px'}}>
              <label style={styles.qTitle}>Q3: Deep Storytelling (Founder-Level Thinking)</label>
              <p style={{fontSize: '16px', fontWeight: '500', marginBottom: '10px'}}>Write a 5-line story for a sleep tracking device.</p>
              <div style={styles.guidance}>
                <strong>Constraints:</strong> No tech talk. Focus on human problem: stress, burnout.
              </div>
              <textarea name="q3" value={formData.q3} style={styles.textarea} onChange={handleChange} required placeholder="5-line story..." />
            </div>

            <button type="submit" style={styles.submitBtn}>Submit Assessment</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NarrativeBuilder;